import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import AIBlockComponent from './AIBlockComponent';

export const AIBlock = Node.create({
  name: 'AiPersonalizedBlock',
  group: 'block',
  atom: true,
  draggable: true,
  parseHTML(arg) {
    return [
      {
        tag: 'ai-personalized-block',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['ai-personalized-block', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AIBlockComponent);
  },
});
